module.exports = __webpack_public_path__ + "static/uipath-aaee57a4c6c1bc05c5f0ce9283ae6a47.jpg";